import { createI18n } from 'vue-i18n'
import { datetimeFormats } from './datetimeFormats'
import { messages } from './messages'

export const i18nSettings = {
  locale: 'en',
  fallbackLocale: 'en',
  messages,
  legacy: false,
  datetimeFormats
}

export const i18n = createI18n(i18nSettings)